import { useEffect, useState } from "react";

export const prefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function useMedia(query) {
  const [match, setMatch] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMatch(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return match;
}

export function useInView(ref, { threshold = 0.2, once = true, rootMargin = "0px" } = {}) {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          if (once) io.disconnect();
        } else if (!once) setInView(false);
      },
      { threshold, rootMargin }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [ref, threshold, once, rootMargin]);
  return inView;
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const reduced = prefersReducedMotion();
  if (window.__lenis && !reduced) {
    window.__lenis.scrollTo(el, { offset: id === "top" ? 0 : -64, duration: 1.4 });
  } else {
    const y = el.getBoundingClientRect().top + window.scrollY - 64;
    window.scrollTo({ top: y, behavior: reduced ? "auto" : "smooth" });
  }
  if (id === "richiedi") {
    setTimeout(() => {
      const first = document.querySelector("[data-lead-autofocus]");
      if (first) first.focus({ preventScroll: true });
    }, reduced ? 50 : 1300);
  }
}
